import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import CookieBanner from './components/feature/CookieBanner';
import ScrollToTop from './components/feature/ScrollToTop';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppRoutes />
      <CookieBanner />
      <ScrollToTop />
    </BrowserRouter>
  );
}

export default App;
